import { NumericTextInputNoScroll } from "@/components/forms/NumericTextInputNoScroll";
import { SpaceValues } from "@/lib/utils/SpaceValues";
import { Box, Heading, Row, Space } from "@stenajs-webui/core";
import * as React from "react";
import { FieldCaption } from "@/components/forms/FieldCaption";
import { PriceCalculatorFormData } from "@/features/price-calculator/types/types";
import { FormModelChangeHandler } from "@/types/forms/types";
import { GapValues } from "@/lib/utils/GapValues";

interface Props {
  formData: PriceCalculatorFormData;
  onChangeFormData: FormModelChangeHandler<PriceCalculatorFormData>;
}

export const PriceCalculatorDriversDetails: React.FC<Props> = ({
  formData,
  onChangeFormData,
}) => {
  return (
    <Box>
      <Heading variant={"h4"}>Drivers and passengers</Heading>
      <Space num={SpaceValues.SIXTEEN} />
      <Row gap={GapValues.TWENTYFOUR}>
        <FieldCaption label={"Adults (16+)"} width={80}>
          <NumericTextInputNoScroll
            value={formData.passengersAdults?.toString()}
            onValueChange={(value) =>
              onChangeFormData("passengersAdults", parseInt(value))
            }
            min={0}
          />
        </FieldCaption>
        <FieldCaption label={"Children (4-15)"} width={80}>
          <NumericTextInputNoScroll
            value={formData.passengersChildren?.toString()}
            onValueChange={(value) =>
              onChangeFormData("passengersChildren", parseInt(value))
            }
            min={0}
          />
        </FieldCaption>
        <FieldCaption label={"Infants (0-3)"} width={80}>
          <NumericTextInputNoScroll
            value={formData.passengersInfants?.toString()}
            onValueChange={(value) =>
              onChangeFormData("passengersInfants", parseInt(value))
            }
            min={0}
          />
        </FieldCaption>
        <FieldCaption label={"No of sleepers"} width={80}>
          <NumericTextInputNoScroll
            value={formData.passengersSleepers?.toString()}
            onValueChange={(value) =>
              onChangeFormData("passengersSleepers", parseInt(value))
            }
            min={0}
          />
        </FieldCaption>
      </Row>
    </Box>
  );
};
